// extracted by mini-css-extract-plugin
export default {"title":"_72274b929b","bld":"_69ee689e30"};